import { api } from "@/api"
import { queryClient } from "@/queryClient"

export const updateProductTag = async (
  productTagId: string,
  params: CreateUpdateProductTagBody
): Promise<undefined> => {
  await api.put<unknown>(
    `/products/product-tags/${productTagId}/`,
    {
      body: params,
    }
  )
  queryClient.invalidateQueries({
    queryKey: [PRODUCT_TAG_QUERY_KEY],
  })
  return
}
